import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const CAC = () => {
    const dummyCAC = 75.25; // Dummy data

    return (
        <Card sx={{
            backgroundColor: '#202020',
            color: '#12c099',
            padding: '1.5rem',
            borderRadius: '12px',
            textAlign: 'center',
            minHeight: '150px',
        }}>
            <CardContent>
                <Typography variant="h6">Customer Acquisition Cost (CAC)</Typography>
                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>${dummyCAC.toFixed(2)}</Typography>
            </CardContent>
        </Card>
    );
};

export default CAC;
